(() => {
  const body = document.body;
  const panel = document.querySelector('[data-mobile-panel]');
  const open = document.querySelector('[data-mobile-open]');
  const close = document.querySelector('[data-mobile-close]');

  const setMenu = (isOpen) => {
    if (!panel) return;
    panel.classList.toggle('is-open', isOpen);
    panel.setAttribute('aria-hidden', String(!isOpen));
    body.classList.toggle('nav-open', isOpen);
    if (open) open.setAttribute('aria-expanded', String(isOpen));
  };

  open?.addEventListener('click', () => setMenu(true));
  close?.addEventListener('click', () => setMenu(false));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setMenu(false);
  });

  document.querySelectorAll('[data-sort-by]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });

  const updateGalleryDots = (shell, activeItem) => {
    if (!shell || !activeItem) return;
    shell.querySelectorAll('[data-gallery-dot]').forEach((dot) => {
      const isActive = dot.dataset.mediaId === activeItem.dataset.mediaId;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  };

  const setGalleryActiveItem = (shell, item) => {
    if (!shell || !item) return;
    const gallery = shell.querySelector('[data-product-gallery]');
    gallery?.querySelectorAll('[data-product-media]').forEach((galleryItem) => {
      galleryItem.classList.toggle('is-active', galleryItem === item);
    });
    updateGalleryDots(shell, item);

    const activeDot = shell.querySelector(`[data-gallery-dot][data-media-id="${item.dataset.mediaId}"]`);
    const dotRail = activeDot?.parentElement;
    if (activeDot && dotRail) {
      const left = Math.max(0, activeDot.offsetLeft - ((dotRail.clientWidth - activeDot.offsetWidth) / 2));
      dotRail.scrollTo({ left, behavior: 'smooth' });
    }
  };

  document.querySelectorAll('[data-product-gallery-shell]').forEach((shell) => {
    const gallery = shell.querySelector('[data-product-gallery]');
    const items = () => [...gallery.querySelectorAll('[data-product-media]')];

    const showItem = (item) => {
      if (!item) return;
      setGalleryActiveItem(shell, item);
    };

    const initialItem = gallery.querySelector('.is-lead') || items()[0];
    if (initialItem) setGalleryActiveItem(shell, initialItem);

    shell.querySelectorAll('[data-gallery-dot]').forEach((dot) => {
      dot.addEventListener('click', (event) => {
        event.preventDefault();
        showItem(gallery.querySelector(`[data-media-id="${dot.dataset.mediaId}"]`));
      });
    });

    shell.querySelector('[data-gallery-previous]')?.addEventListener('click', () => {
      const list = items();
      if (!list.length) return;
      const current = gallery.querySelector('.is-active') || list[0];
      showItem(list[Math.max(0, list.indexOf(current) - 1)]);
    });

    shell.querySelector('[data-gallery-next]')?.addEventListener('click', () => {
      const list = items();
      if (!list.length) return;
      const current = gallery.querySelector('.is-active') || list[0];
      showItem(list[Math.min(list.length - 1, list.indexOf(current) + 1)]);
    });
  });

  document.querySelectorAll('[data-product-select]').forEach((select) => {
    const productForm = select.closest('form');
    const variantChoices = [...select.options];
    const swatchColors = {
      'black': '#111111',
      'white': '#ffffff',
      'bio white': '#f7f5ed',
      'vintage white': '#f1eadb',
      'pink': '#e998b5',
      'light pink': '#efc2cf',
      'soft pink': '#efc4cb',
      'blossom': '#e9a6b4',
      'azalea': '#df6f9b',
      'safety pink': '#e86a93',
      'hot pink': '#f34b91',
      'heliconia': '#d94381',
      'watermelon': '#ef6f78',
      'red': '#c83a3a',
      'crimson': '#9f263a',
      'cardinal': '#8c2332',
      'cranberry': '#8f3046',
      'burgundy': '#722f37',
      'wine': '#786570',
      'maroon': '#6f263d',
      'orange': '#e98135',
      'yellow': '#f2cf4a',
      'butter': '#f3df87',
      'cream': '#f4edda',
      'ivory': '#f4f0e6',
      'natural': '#e7ddc5',
      'charlotte': '#29a09e',
      'stone': '#c8c0ad',
      'beige': '#d8c4a5',
      'sand': '#cbbd9d',
      'tan': '#c5a47e',
      'brown': '#76513c',
      'dark chocolate': '#3b2925',
      'navy': '#1f2a44',
      'navy blue': '#1f2a44',
      'dark navy': '#17243b',
      'heather sport dark navy': '#27384a',
      'midnight': '#202b3d',
      'indigo': '#3e5f7f',
      'indigo blue': '#3e5f7f',
      'denim': '#526f85',
      'washed denim': '#718a9c',
      'blue jean': '#5f788b',
      'blue': '#356a9a',
      'royal blue': '#2754a6',
      'light blue': '#a9cce5',
      'sky blue': '#87ceeb',
      'chambray': '#9db9c8',
      'columbia blue': '#a9c9dd',
      'carolina blue': '#86b5d8',
      'antique sapphire': '#287b98',
      'purple': '#74528d',
      'lavender': '#b7a5d8',
      'kelly': '#2a6d5b',
      'kelly green': '#2a6d5b',
      'hunter green': '#143f34',
      'forest green': '#214e34',
      'forest': '#214e34',
      'dark green': '#143f34',
      'green': '#47775c',
      'light green': '#a9c3a1',
      'irish green': '#168c57',
      'military green': '#5d6245',
      'mint green': '#a8cdb8',
      'safety green': '#c7d64b',
      'sage': '#9aaa8b',
      'olive': '#73734b',
      'loden': '#536052',
      'spruce': '#31574f',
      'blue spruce': '#456b70',
      'moss': '#69705a',
      'khaki': '#b7a47a',
      'bay': '#6f8c86',
      'grey': '#9a9a9a',
      'gray': '#9a9a9a',
      'sport grey': '#b9b9b7',
      'sport gray': '#b9b9b7',
      'ash': '#d0d1cf',
      'heather grey': '#b2b2b2',
      'heather gray': '#b2b2b2',
      'dark heather': '#45484b',
      'graphite heather': '#565b5c',
      'charcoal': '#4d5054',
      'granite': '#777a76',
      'pepper': '#585953',
      'brick': '#a9574e',
      // FGO candle scents: muted, scent-inspired swatches.
      'christmas warmth': '#9b3d4a',
      'sea salt and orchid': '#b7a5c9',
      'white sage and lavender': '#a8b29a',
      'white sage + lavender': '#a8b29a',
      'coconut cream and cardamom': '#e8d9b7',
      'coconut cream + cardamom': '#e8d9b7',
      'cinnamon vanilla': '#b77a55',
      'clean cotton': '#c9d8e5'
    };
    const resolveSwatchColor = (name) => {
      const normalized = name.trim().toLowerCase().replace(/\s+/g, ' ');
      if (swatchColors[normalized]) return swatchColors[normalized];
      const closestKnownColor = Object.keys(swatchColors)
        .sort((first, second) => second.length - first.length)
        .find((colorName) => normalized.includes(colorName));
      if (closestKnownColor) return swatchColors[closestKnownColor];
      if (window.CSS?.supports?.('color', normalized)) return normalized;
      return '#d9d9d9';
    };
    const isLightSwatch = (color) => {
      const hex = color.match(/^#([0-9a-f]{6})$/i)?.[1];
      if (!hex) return false;
      const red = parseInt(hex.slice(0, 2), 16);
      const green = parseInt(hex.slice(2, 4), 16);
      const blue = parseInt(hex.slice(4, 6), 16);
      return ((red * 299) + (green * 587) + (blue * 114)) / 1000 > 175;
    };

    productForm?.querySelectorAll('[data-color-swatch]').forEach((button) => {
      // Keep each two-tone variant evenly split between its named colors.
      const names = button.dataset.optionValue.split('/').map((name) => name.trim()).filter(Boolean);
      const color = resolveSwatchColor(names[0] || button.dataset.optionValue);
      const secondColor = names[1] ? resolveSwatchColor(names[1]) : color;
      const background = names.length === 2
        ? `linear-gradient(90deg, ${color} 0%, ${color} 50%, ${secondColor} 50%, ${secondColor} 100%)`
        : color;
      button.style.setProperty('--swatch-background', background);
      button.style.setProperty('--swatch-check', isLightSwatch(color) ? '#143f34' : '#ffffff');
    });
    const optionValues = (choice) => {
      try {
        return JSON.parse(choice.dataset.options || '[]');
      } catch (_error) {
        return [];
      }
    };

    const colorIndex = Number(productForm?.querySelector('[data-color-option]')?.dataset.optionIndex ?? -1);
    let previousChoice = select.options[select.selectedIndex];

    const syncOptionButtons = () => {
      const selectedChoice = select.options[select.selectedIndex];
      if (!selectedChoice) return;
      const selectedValues = optionValues(selectedChoice);

      productForm?.querySelectorAll('[data-option-group]').forEach((group) => {
        const index = Number(group.dataset.optionIndex);
        const currentLabel = group.querySelector('[data-option-current]');
        if (currentLabel) currentLabel.textContent = selectedValues[index] || '';

        group.querySelectorAll('[data-option-button]').forEach((button) => {
          const isSelected = button.dataset.optionValue === selectedValues[index];
          const isAvailable = variantChoices.some((choice) => {
            if (choice.dataset.available !== 'true') return false;
            const values = optionValues(choice);
            return values[index] === button.dataset.optionValue &&
              (button.hasAttribute('data-color-swatch') || values.every((value, position) => position === index || value === selectedValues[position]));
          });
          button.classList.toggle('is-selected', isSelected);
          button.setAttribute('aria-pressed', String(isSelected));
          button.disabled = !isAvailable;
        });
      });
    };

    productForm?.querySelectorAll('[data-option-button]').forEach((button) => {
      button.addEventListener('click', () => {
        const index = Number(button.dataset.optionIndex);
        const currentChoice = select.options[select.selectedIndex];
        const selectedValues = optionValues(currentChoice);
        selectedValues[index] = button.dataset.optionValue;

        const exactChoice = variantChoices.find((choice) => {
          const values = optionValues(choice);
          return choice.dataset.available === 'true' && values.every((value, position) => value === selectedValues[position]);
        });
        const compatibleChoice = exactChoice || variantChoices.find((choice) => {
          if (choice.dataset.available !== 'true') return false;
          const values = optionValues(choice);
          return values[index] === button.dataset.optionValue &&
            (button.hasAttribute('data-color-swatch') || values.every((value, position) => position === index || value === selectedValues[position]));
        });

        if (!compatibleChoice) return;
        select.value = compatibleChoice.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      if (!option) return;
      const previousValues = previousChoice ? optionValues(previousChoice) : [];
      const currentValues = optionValues(option);
      const sameColor = colorIndex >= 0 && previousValues[colorIndex] === currentValues[colorIndex];
      previousChoice = option;
      const form = select.closest('form');
      const idInput = form?.querySelector('input[name="id"]');
      const addButton = form?.querySelector('[data-add-to-bag]');
      const addLabel = form?.querySelector('[data-add-label]');
      const price = document.querySelector('[data-product-price] .price');
      const available = option.dataset.available === 'true';
      if (idInput) idInput.value = option.value;
      if (addButton) addButton.disabled = !available;
      if (addLabel) addLabel.textContent = available ? `Add to bag — ${option.dataset.price}` : 'Sold out';
      if (price) {
        price.replaceChildren();
        if (option.dataset.comparePrice) {
          const compare = document.createElement('s');
          compare.textContent = option.dataset.comparePrice;
          const sale = document.createElement('span');
          sale.className = 'price__sale';
          sale.textContent = option.dataset.price;
          price.append(compare, sale);
        } else {
          const regular = document.createElement('span');
          regular.textContent = option.dataset.price;
          price.append(regular);
        }
      }

      // Size-only changes preserve the shopper's current color photograph.
      // Change media only when the color changes (or there is no color option).
      if (!sameColor) {
      const productPage = select.closest('.product-page') || document;
      const gallery = productPage.querySelector('[data-product-gallery]');
      const shell = gallery?.closest('[data-product-gallery-shell]');
      let media = option.dataset.mediaId ? gallery?.querySelector(`[data-media-id="${option.dataset.mediaId}"]`) : null;

      // Some fulfillment apps provide a variant image URL without a featured-media ID.
      // Match that URL back to its gallery item before falling back to the lead image.
      if (!media && option.dataset.imageSrc && gallery) {
        const variantPath = new URL(option.dataset.imageSrc, window.location.origin).pathname;
        media = [...gallery.querySelectorAll('[data-product-media]')].find((item) => {
          const itemImage = item.querySelector('img');
          if (!itemImage) return false;
          return new URL(itemImage.currentSrc || itemImage.src, window.location.origin).pathname === variantPath;
        }) || null;
      }

      if (gallery && media) {
        if (window.matchMedia('(max-width: 999px)').matches) {
          // Use explicit visibility instead of scroll snapping so iOS Safari cannot
          // keep a neighboring image on screen after a variant change.
          setGalleryActiveItem(shell, media);
        } else {
          gallery.querySelector('.is-lead')?.classList.remove('is-lead');
          media.classList.add('is-lead');
          gallery.querySelectorAll('[data-product-media]').forEach((item) => item.classList.toggle('is-active', item === media));
          gallery.prepend(media);
          updateGalleryDots(shell, media);
        }
      } else if (gallery && option.dataset.imageSrc) {
        // Last-resort support for imported variants whose image is not in product.media.
        const lead = gallery.querySelector('.is-lead') || gallery.querySelector('[data-product-media]');
        const leadImage = lead?.querySelector('img');
        if (leadImage) {
          leadImage.src = option.dataset.imageSrc;
          leadImage.srcset = '';
          leadImage.alt = option.dataset.variantTitle || leadImage.alt;
          const zoomButton = lead.querySelector('[data-gallery-zoom]');
          if (zoomButton) zoomButton.dataset.zoomSrc = option.dataset.imageSrc;
          setGalleryActiveItem(shell, lead);
        }
      }

      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url.toString());
      syncOptionButtons();
    });

    syncOptionButtons();
  });

  const lightbox = document.querySelector('[data-product-lightbox]');
  if (lightbox) {
    const image = lightbox.querySelector('[data-lightbox-image]');
    let activeZoomButton = null;

    const zoomButtons = () => [...document.querySelectorAll('[data-gallery-zoom]')];
    const openLightbox = (button) => {
      activeZoomButton = button;
      image.src = button.dataset.zoomSrc;
      image.alt = button.getAttribute('aria-label')?.replace(/^Zoom\s*/, '') || 'Product image';
      lightbox.hidden = false;
      document.body.classList.add('lightbox-open');
      lightbox.querySelector('[data-lightbox-close]')?.focus();
    };
    const closeLightbox = () => {
      lightbox.hidden = true;
      document.body.classList.remove('lightbox-open');
      activeZoomButton?.focus();
    };
    const moveLightbox = (direction) => {
      const buttons = zoomButtons();
      const index = buttons.indexOf(activeZoomButton);
      activeZoomButton = buttons[(index + direction + buttons.length) % buttons.length];
      image.src = activeZoomButton.dataset.zoomSrc;
      image.alt = activeZoomButton.getAttribute('aria-label')?.replace(/^Zoom\s*/, '') || 'Product image';
    };

    zoomButtons().forEach((button) => button.addEventListener('click', () => openLightbox(button)));
    lightbox.querySelector('[data-lightbox-close]')?.addEventListener('click', closeLightbox);
    lightbox.querySelector('[data-lightbox-previous]')?.addEventListener('click', () => moveLightbox(-1));
    lightbox.querySelector('[data-lightbox-next]')?.addEventListener('click', () => moveLightbox(1));
    lightbox.addEventListener('click', (event) => { if (event.target === lightbox) closeLightbox(); });
    document.addEventListener('keydown', (event) => {
      if (lightbox.hidden) return;
      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowLeft') moveLightbox(-1);
      if (event.key === 'ArrowRight') moveLightbox(1);
    });
  }
})();
